//
import { mapActions } from 'vuex'
import { ModelForm } from '@/components/reusable_components/next'
import Translator from '@/services/translator'

//
import RepackingHistoricModel from '@/models/Warehouse/WhRepackingHistoric'
import fields from './fields'

//
export default {
    name: 'repacking-historic-create',
    components: {
        'model-form': ModelForm,
    },
    computed: {
        /**
         *
         */
        formProps() {
            return {
                editable: false,
                fields,
            }
        },
    },
    data() {
        return {
            formData: {},
        }
    },
    methods: {
        //
        ...mapActions('MenuesModule', {
            setAppToolbarTitle: 'setAppToolbarTitle',
        }),

        //
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            hideSnack: 'hideSnack',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),

        /**
         *
         */
        reset() {
            RepackingHistoricModel.modeler()
                .find(this.$route.params.id)
                .then(this.setFormData)
        },

        /**
         *
         */
        setFormData(model) {
            this.formData = model.reset()
        },

        /**
         *
         */
        showError(error) {
            this.showSnackbar(
                'error',
                'Error.',
                Translator(RepackingHistoricModel, error.response.data)
            )
        },

        /**
         *
         */
        showSnackbar(type, title, message, callback) {
            this.initSnackbar(this.fillSnack(type, title, message))
            if (typeof callback === 'function') callback()
        },

        /**
         *
         */
        showSuccess() {
            this.showSnackbar(
                'success',
                'Éxito.',
                'Reenvasado agregado.',
                this.redirect
            )
        },

        /**
         *
         */
        submit() {
            this.$refs.form.setWait(true).then(this.create)
        },
    },
    beforeMount() {
        this.setAppToolbarTitle({ title: 'Datos de reenvasado' })
    },
    mounted() {
        this.reset()
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('VIEW_DETAIL_PRODUCT_REPACKING_HISTORIC'))
                ctx.$router.push('/')
        })
    },
}
